import * as React from 'react';
import { Button, Provider, teamsTheme, Text, Image, Layout, Flex, Segment, Header, Loader, ErrorIcon, OpenOutsideIcon } from '@fluentui/react-northstar';
import { app, authentication, } from '@microsoft/teams-js';
import Styles from '../styles/Styles';
import axios from 'axios';
import AuthHelper from '../helpers/Auth-Helper';
import { Helpers } from '../helpers/Helpers';

var userIdentifier;
class SignIn extends React.Component {
    constructor(props) {
        super(props);
        this.state = { isAuthorized: false, isLoggedIn: false, isLicensed: Helpers.getUrlPar('isLicensed') === 'true', textLabel: 'Loading...', isLoading: true }
        this.handleSignInClick = this.handleSignInClick.bind(this);

    }
    componentDidMount() {
        app.getContext()
            .then(context => {
                //Initiating            
                userIdentifier = context.user.id + '.' + context.user.tenant.id;
                axios.get("/account/CheckAuthorization")
                    .then(response => {
                        if (response.data != null) {
                            try {
                                var result = response.data;
                                var microsoft = result === true;

                                var text = `To start using ${Helpers.getAppName()} in Microsoft Teams.`;
                                if (!microsoft)
                                    text = 'Step 1: Sign in with Microsoft';
                                else {
                                    text = `Step 2: Sign in with ${Helpers.getAppName()}`;
                                }
                                this.setState({ isAuthorized: microsoft, isLoggedIn: false, textLabel: text, isLoading: false });
                            }
                            catch (err) {
                            }
                        }
                    });
            });
    }
    fireLoginEvent() {
        window.location.href = this.props.from ?? '/home';
    }
    handleSignInClick(e, props) {
        e.preventDefault();
        e.stopPropagation();
        this.setState({ isLoading: true });
        axios.get("/account/CheckAuthorization")
            .then(response => {
                if (response.data != null) {
                    try {
                        var result = response.data;
                        var microsoft = result === true;
                        var text = 'Authorization';
                        if (!microsoft)
                            text = 'Step 1: Sign in with Microsoft';
                        else
                            text = `Step 2: Sign in with ${Helpers.getAppName()}`;

                        this.setState({ isAuthorized: microsoft, isLoggedIn: false, textLabel: text });
                        if (this.props.isMobile && microsoft) {
                            //Navigate to login screen
                            window.location.href = "/login";
                        }
                        else {
                            var url = window.location.origin + (this.state.isAuthorized ? "/login" : "/account/Login");
                            var self = this;
                            let frameContext = app.getFrameContext();
                            if (frameContext === 'authentication') {
                                window.location.href = '/login';
                            }
                            else {
                                authentication.authenticate({
                                    url: url,
                                    width: 350,
                                    height: 800,
                                }).then(result => {
                                    if (result != null) {
                                        console.log(result);
                                        var data = result;
                                        var apiKey = data.apiKey ?? data.success.data.token;
                                        var baseUrl = data.url ?? data.instanceUrl;
                                        var installationType = data.installationType ?? "on-cloud";

                                        let formData = new FormData();
                                        formData.append('res[data][url]', baseUrl);
                                        formData.append('res[data][key]', apiKey);
                                        formData.append('res[data][installationType]', installationType);

                                        //Save in browser storage and backend session

                                        localStorage.setItem('user-identifier', userIdentifier);

                                        if (baseUrl != null && apiKey != null) {

                                            axios.post('/account/SaveCredentials', formData)
                                                .then(response => {
                                                    //Save to local storage                                                                
                                                    Helpers.saveToLocalStorage('url', baseUrl);
                                                    Helpers.saveToLocalStorage('apiKey', apiKey);
                                                    Helpers.saveToLocalStorage('installationType', installationType);
                                                    self.fireLoginEvent();
                                                })
                                                .catch(error => {
                                                })
                                        }
                                    }
                                    else {
                                        self.fireLoginEvent();
                                    }
                                })
                                    .catch(reason => {
                                        self.fireLoginEvent();
                                    });
                            }
                        }
                    }
                    catch (err) {
                        console.error(err);
                        window.close();
                    }
                }
            });
    }
    render() {
        return (
            <Flex column hAlign="center" vAlign="center" styles={{ height: '100vh', backgroundColor: this.props.theme == 'default' ? '#F5F5F5' : (this.props.theme == 'dark' ? '#2d2c2c' : '#000') }} gap='gap.large'>
                <Flex gap="gap.medium" column hAlign="center" vAlign="center" key="center" styles={Styles.layoutStyle}>
                    <Image src={require('../Images/teamsconnect-logo.png')} style={{ maxWidth: '50%' }} />
                    {(!this.state.isLicensed && this.state.isLoggedIn) ? <Header as="h4" styles={{ color: "red" }} content={`Not licensed, please subscribe to this application via ${Helpers.getAppName()} core.`} /> : <div />}
                    <Flex hAlign="center" vAlign="center" styles={{ width: '100%', textAlign: 'center' }}>
                        <Header as='h4' content={this.state.textLabel} />
                    </Flex>
                    {this.state.isLoading ? <Loader /> : <Button primary onClick={this.handleSignInClick}>{!this.state.isAuthorized ? "Sign in using Microsoft" : `Sign in using ${Helpers.getAppName()}`}</Button>}
                </Flex>
                {this.props.validAccount ? <div /> : <Flex inline gap='gap.small'>
                    <ErrorIcon />
                    <Text content='You are logged in with a different Microsoft account used in Microsoft Teams, please use the same one.' />
                </Flex>}
                <Button icon={<OpenOutsideIcon />} iconPosition='after' secondary content='First time? Sign up for free' onClick={(e, props) => {
                    e.preventDefault();
                    e.stopPropagation();
                    window.open(`https://site.${Helpers.getAppId()}.com/users/signup.php?lang=en`);
                }} />
                <Text content={'V.' + Helpers.getAddonVersion()} />
            </Flex>
        );
    }
}
export default SignIn;